module.exports = __webpack_public_path__ + "img/forums.060ef798.svg";